import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#2C2A28] text-[#E5E0D8] mt-24">
      <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="bg-white rounded-xl p-1.5 inline-flex">
              <img src="/roadtogo-logo.png" alt="RoadToGo" className="h-10 w-auto object-contain" />
            </span>
            <span className="font-serif text-2xl">RoadToGo Europe</span>
          </div>
          <p className="text-sm text-[#A8A29A] max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase text-[#8C857B] mb-4">{t("footer.explore")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pays" className="hover:text-[#E06D53] transition-colors">{t("footer.countries")}</Link></li>
            <li><Link to="/tarifs" className="hover:text-[#E06D53] transition-colors">{t("footer.plans")}</Link></li>
            <li><Link to="/inscription" className="hover:text-[#E06D53] transition-colors">{t("footer.create")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase text-[#8C857B] mb-4">{t("footer.covered")}</h4>
          <ul className="space-y-2 text-sm">
            <li>🇫🇷 France</li>
            <li>🇨🇭 Suisse</li>
            <li>🇮🇹 Italie</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#8C857B]">
        © {new Date().getFullYear()} RoadToGo Europe · {t("footer.rights")}
      </div>
    </footer>
  );
}
